import React from 'react';
import PropTypes from 'prop-types';
import {hasValue} from '../../../utils/utils';
import {filterIcon, deleteIcon, newIcon, refreshIcon, revertIcon, saveIcon, 
   clearIcon, seamlessLoginIcon, filterBadgeIcon, cloneIcon, changeIcon} from '../../../assets/images/buttons';
import searchIcon from '../../../assets/images/search_magnifiy.svg';
import connectedIcon from '../../../assets/images/gateway/connected.png';
import disconnectedIcon from '../../../assets/images/gateway/disconnected.png';
import disabledIcon from '../../../assets/images/gateway/disabled.png';
import calendarIcon from '../../../assets/images/calendar.svg';
import greenCheckIcon from '../../../assets/images/green_check.png';
import redXIcon from '../../../assets/images/red_x.png';
import infoIcon from '../../../assets/images/info.png';
import editIcon from '../../../assets/images/edit.png';
import warningIcon from '../../../assets/images/warning.png';
import rightArrowIcon from '../../../assets/images/right_arrow.png';
import plusIcon from '../../../assets/images/plus.svg';
import hideEyeIcon from '../../../assets/images/hide_eye.svg';
import viewEyeShowIcon from '../../../assets/images/view_eye_show.svg';
import hideEyeFullIcon from '../../../assets/images/hide_eye_full.svg';
import viewEyeShowFullIcon from '../../../assets/images/view_eye_show_full.svg';
import copyIcon from '../../../assets/images/copy.svg';
import downArrow from '../../../assets/images/downArrow.png';

export const Icons = {
    'filter': { icon: filterIcon, alt: 'filter' },
    'filterWithBadge': { icon: filterBadgeIcon, alt: 'filter' },
    'delete': { icon: deleteIcon, alt: 'delete' },
    'new': { icon: newIcon, alt: 'new' },
    'refresh': { icon: refreshIcon, alt: 'refresh' },
    'revert': { icon: revertIcon, alt: 'revert' },
    'save': { icon: saveIcon, alt: 'save' },
    'clear': { icon: clearIcon, alt: 'clear' },
    'seamlessLogin': { icon: seamlessLoginIcon, alt: '' },
    'search': { icon: searchIcon, alt: 'search' },
    'connected': { icon: connectedIcon, alt: 'connected' },
    'disconnected': { icon: disconnectedIcon, alt: 'disconnected' },
    'disabled': { icon: disabledIcon, alt: 'disabled' },
    'calendar': { icon: calendarIcon, alt: 'calendar' },
    'greenCheck': { icon: greenCheckIcon, alt: 'greenCheck' },
    'redX': { icon: redXIcon, alt: 'redX' },
    'info': { icon: infoIcon, alt: 'info' },
    'edit': { icon: editIcon, alt: 'edit' },
    'warning': { icon: warningIcon, alt: 'warning' },
    'rightArrow': { icon: rightArrowIcon, alt: 'rightArrow' },
    'plus': { icon: plusIcon, alt: 'plus' },
    'eye': { icon: viewEyeShowIcon, alt: 'eye' },
    'hideEye': { icon: hideEyeIcon, alt: 'hide' },
    'eyeFull': { icon: viewEyeShowFullIcon, alt: 'eye' },
    'hideEyeFull': { icon: hideEyeFullIcon, alt: 'hide' },
    'copy': { icon: copyIcon, alt: 'copy' },
    'switch': { icon: changeIcon, alt: 'switch' },
    'clone': { icon: cloneIcon, alt: 'clone' },
    'downArrow':{icon:downArrow, alt: 'downArrow'}
}

/**
 * 
 * @param {Object} params
 * @param {('filter'|'delete'|'new'|'refresh'|'revert'|'save'|'clear'|'search'|'connected'|'disconnected'|'disabled'|'greenCheck'|'redX'|'info'|'edit'|'warning'|'rightArrow'|'plus'|'seamlessLogin'|'eye'|'hideEye'|'eyeFull'|'hideEyeFull'|'copy')} params.icon
 * @param {string} params.alt
 * @param {object} params.style
 * @param {string} params.className
 */
function SMCIcon({
    icon,
    alt,
    title,
    style,
    align,
    className,
    onClick
}) {
    const iconData = Icons[icon];
    const iconSrc = iconData ? iconData.icon : undefined;
    const iconAlt = iconData ? iconData.alt  : undefined;
    return (
        <img
            onClick={onClick}
            src={iconSrc}
            alt={hasValue(alt) ? alt : iconAlt}
            style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
            className={className}
            align={align}
            title={title}
        />
    );
}

SMCIcon.propTypes = {
    icon: PropTypes.oneOf(['filter', 'filterWithBadge','delete','new','refresh','revert','save','clear', 'seamlessLogin', 'search', 'connected', 'disconnected', 'disabled', 'calendar', 'greenCheck', 'redX', 'info', 'edit', 'warning', 'rightArrow', 'plus', 'eye', 'hideEye', 'eyeFull', 'hideEyeFull', 'copy','downArrow','cloneIcon','changeIcon']),
    alt: PropTypes.string,
    title: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string
}

export default React.memo(SMCIcon);